export default "__VITE_ASSET__CoZXQl0b__"